module.exports = __webpack_public_path__ + "static/img/construction-objectives-list-1.42aa48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction-objectives-list-1.png
// module id = Vmd5
// module chunks = 1